export type LegendFontConfig = {
  size?: number;
  family?: string;
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

// Reads the supported legend font values without trusting the free-form API configuration.
export const getLegendFontConfig = (
  config: unknown
): LegendFontConfig | undefined => {
  if (!isRecord(config) || !isRecord(config.plugins)) {
    return undefined;
  }

  const { legend } = config.plugins;
  if (!isRecord(legend) || !isRecord(legend.labels)) {
    return undefined;
  }

  const { font } = legend.labels;
  if (!isRecord(font)) {
    return undefined;
  }

  const size = typeof font.size === 'number' ? font.size : undefined;
  const family = typeof font.family === 'string' ? font.family : undefined;

  return size === undefined && family === undefined
    ? undefined
    : { size, family };
};
